<template>
  <v-container class='scramble-form'>
    <single-scramble :scramble='scramble' :type='type' />
    <v-text-field class='solve-time-text' autocomplete='off' v-model='currentTimeStr' label='Enter time including penalties' placeholder='XX:XX.XX'
      :rules='[() => this.currentTime ? true : `Time must be entered in the form (XX:)(XX:)XX.XX(X). Parts in parentheses are optional.`]'
    />
    <v-radio-group v-model='currentMetadata' :mandatory='false'>
      <v-radio label='OK' value='ok'></v-radio>
      <v-radio label='+2' value='+2'></v-radio>
      <v-radio label='DNF' value='dnf'></v-radio>
      <v-radio label='DNS' value='dns'></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
import utils from '@/modules/utils'

import SingleScramble from '@/components/TPC/Shared/SingleScramble'

export default {
  name: 'scramble-form',
  components: {
    SingleScramble
  },
  data () {
    return {
      // current solve info
      currentTimeStr: '',
      currentMetadata: 'ok'
    }
  },
  props: {
    scramble: String,
    type: String,
    value: Object
  },
  watch: {
    currentSolve () {
      this.$emit('input', {
        time: this.currentTime,
        metadata: this.currentMetadata
      })
    }
  },
  computed: {
    currentTime () {
      const input = this.currentTimeStr.split('').reverse().join('') // match on the reversed string so we match the milliseconds first.
      const matches = input.match(/^(\d{2,3})\.(\d+):?(\d*):?(\d*)$/)
      if (matches === null) return // timer input doesn't match so exit without storing time (eg. input contains letters)
      if (matches[1] && matches[1].length < 3) matches[1] = matches[1].padStart(3, '0')
      const units = matches.slice(1).map(v => (v ? parseInt(v.split('').reverse().join(''), 10) : 0))

      return units[0] + 1000 * units[1] + 60000 * units[2] + 3600000 * units[3]
    },
    currentSolve () {
      return `${this.currentTime}|${this.currentMetadata}`
    }
  },
  created () {
    if (this.value.time) {
      this.currentTimeStr = utils.displayTime(this.value.time)
    }
    if (this.value.metadata) {
      this.currentMetadata = this.value.metadata
    }
  }
}
</script>

<style scoped>
.scramble-form {
  display: inline-block;
  width: 50%;
}

::v-deep input {
  font-size: 5vh;
  max-height: unset !important;
}
</style>
